<template>
  <table
    class="table table-bordered table-striped"
    v-if="financingProgram === 'supplier'"
  >
    <caption>
      Rincian Rekening Hibank {{ financingProgram === "supplier" ? "Pembayaran" : "" }}
    </caption>
    <tbody>
      <tr>
        <td>Nomor Rekening</td>
        <td v-if="isEditing">
          <form
            class="d-flex gap-2 justify-content-between"
            @submit.prevent="handleCheckUserDetail"
          >
            <input
              v-model="localEscrowNumber"
              class="form-control border"
              placeholder="Masukan nomor rekening bank escrow Anda"
              @keypress="isNumber($event)"
              @keyup.delete="isNumber($event)"
              @paste="isNumber($event)"
            />

            <button
              type="submit"
              class="btn btn-light text-nowrap px-4 fw-bold"
              :disabled="!localEscrowNumber"
            >
              Cek Rekening
            </button>

            <button
              type="button"
              class="btn btn-primary px-4 fw-bold"
              :disabled="!localEscrowAccount || !hasCheckedAccount"
              @click="handleCloseEditing"
            >
              Simpan
            </button>
          </form>

          <div
            v-if="!isEditing"
            class="d-flex justify-content-between align-items-center"
          >
            <span v-if="!localEscrowNumber" class="color-grey"
              >Masukan nomor rekening bank escrow Anda</span
            >
            <span v-if="localEscrowNumber">{{ localEscrowNumber }}</span>

            <Icon
              v-if="showEditIcon"
              @click="handleOpenEditing"
              name="Pencil"
              size="md"
              color="black"
              class="cursor-pointer me-2"
            />
          </div>
        </td>
        <th scope v-else>
          <div class="d-flex justify-content-between align-items-center">
            <span v-if="!localEscrowNumber" class="color-grey">
              Masukan nomor rekening bank escrow Anda
            </span>
            <span v-else>{{ localEscrowNumber }}</span>
            
            <Icon
              v-if="showEditIcon"
              @click="handleOpenEditing"
              name="Pencil"
              size="md"
              color="black"
              class="cursor-pointer"
            />
          </div>
        </th>
      </tr>
      <tr>
        <td>Nama Pemilik Rekening</td>
        <th scope>
          <div class="d-flex justify-content-between align-items-center">
            <span>{{ localEscrowAccount || '-' }}</span>
          </div>
        </th>
      </tr>
    </tbody>
  </table>
</template>

<script>
import mixin from "@/mixin";

export default {
  name: "EscrowAccountBankStyle",
  mixins: [mixin],
  props: {
    financingProgram: {
      type: String,
      required: true,
    },
    escrowNumber: {
      type: String,
      default: "",
    },
    escrowAccount: {
      type: String,
      default: "",
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    showEditIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localEscrowNumber: this.escrowNumber,
      localEscrowAccount: this.escrowAccount,
      hasCheckedAccount: false,
    };
  },
  watch: {
    escrowNumber(newVal) {
      this.localEscrowNumber = newVal;
      this.hasCheckedAccount = false;
    },
    escrowAccount(newVal) {
      this.localEscrowAccount = newVal;
    },
    localEscrowNumber(newVal) {
      this.$emit('update:escrow-number', newVal);
    },
    localEscrowAccount(newVal) {
      this.$emit('update:escrow-account', newVal);
    },
  },
  methods: {
    handleCheckUserDetail() {
      if (!this.localEscrowNumber) return;
      // Set the flag to indicate check has been performed
      this.hasCheckedAccount = true;
      // Emit the current escrow number to parent for verification
      this.$emit("check-user-detail", this.localEscrowNumber);
    },
    handleOpenEditing() {
      // Reset the flag when opening edit mode
      this.hasCheckedAccount = false;
      this.$emit("open-editing");
    },
    handleCloseEditing() {
      // Emit updated values before closing
      this.$emit('update:escrow-number', this.localEscrowNumber);
      this.$emit('update:escrow-account', this.localEscrowAccount);
      // Reset the flag when closing edit mode
      this.hasCheckedAccount = false;
      this.$emit("close-editing");
    },
  },
};
</script>

<style scoped>
::placeholder {
  color: #b6b6b6;
}

.form-control,
.btn {
  padding: 0.75rem !important;
  font-size: 15px !important;
}

.btn-white {
  background-color: white;
}

.btn-light {
  font-size: 14px !important;
  background-color: transparent !important;
  color: #00697f !important;
}

.btn-transparent {
  background-color: transparent;
  border: none !important;
  font-size: 0;
  border-color: #fff;
  box-shadow: 0px 0px 0px 0px #fff;
}

.btn-transparent.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

th,
td {
  width: 50%;
  padding: 8px 16px !important;
  height: 56px;
  vertical-align: middle;
}

.color-grey {
  color: #b6b6b6;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
